module.exports = __webpack_public_path__ + "img/Airbnb-donut-table-small.bdd10273.jpg";